export class PlanContentsInfo {
  constructor(
    public contentsId: number, // コンテンツID
    public contentsType: string, // コンテンツタイプ
    public isPublic: boolean, // 公開フラグ
    public publishedAt: Date | null, // 公開日時
    public createdAt: Date | null, // 作成日時
    public updatedAt: Date | null, // 更新日時
    public limitedPlanPriceIds?: number[], // プラン制限: 未読判定を行う対象のプランPriceIDリスト
    public viewingRestrictionDays?: number, // 閲覧制限日数: 入会から何日経過しないと閲覧できないか
  ) {}

  public static empty(): PlanContentsInfo {
    return new PlanContentsInfo(0, "", false, null, null, null, [], undefined);
  }
}

// Firestore data converter
export const PlanContentsInfoConverter = {
  toFirestore: (item: any) => {
    return {
      contents_id: item.contentsId,
      contents_type: item.contentsType,
      is_public: item.isPublic,
      published_at: item.publishedAt,
      created_at: item.createdAt,
      updated_at: item.updatedAt,
      limited_plan_price_ids: item.limitedPlanPriceIds,
      viewing_restriction_days: item.viewingRestrictionDays,
    };
  },
  fromFirestore: (snapshot: any, options: any) => {
    const data = snapshot.data(options);
    return new PlanContentsInfo(
      data.contents_id,
      data.contents_type,
      data.is_public,
      data.published_at ? data.published_at.toDate() : null,
      data.created_at ? data.created_at.toDate() : null,
      data.updated_at ? data.updated_at.toDate() : null,
      data.limited_plan_price_ids,
      data.viewing_restriction_days,
    );
  },
};
